import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface MapState {
  // Estado del mapa
  isInitialized: boolean;
  isReady: boolean;
  center: [number, number];
  zoom: number;
  extent: [number, number, number, number] | null;
  
  // Capas
  layers: {
    base: boolean;
    cadastral: boolean;
    ifc: boolean;
    drawing: boolean;
  };
  
  // Operaciones
  isLoading: boolean;
  error: string | null;
  
  // Acciones
  setInitialized: (initialized: boolean) => void;
  setReady: (ready: boolean) => void;
  setCenter: (center: [number, number]) => void;
  setZoom: (zoom: number) => void;
  setExtent: (extent: [number, number, number, number] | null) => void;
  toggleLayer: (layerName: keyof MapState['layers']) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const initialState = {
  isInitialized: false,
  isReady: false,
  center: [-3.7038, 40.4168] as [number, number], // Madrid, España
  zoom: 12,
  extent: null as [number, number, number, number] | null,
  layers: {
    base: true,
    cadastral: false,
    ifc: false,
    drawing: false,
  },
  isLoading: false,
  error: null,
};

export const useMapStore = create<MapState>()(
  devtools(
    (set, get) => ({
      ...initialState,
      
      setInitialized: (initialized) => set({ isInitialized: initialized }),
      setReady: (ready) => set({ isReady: ready }),
      setCenter: (center) => set({ center }),
      setZoom: (zoom) => set({ zoom }),
      setExtent: (extent) => set({ extent }),
      
      toggleLayer: (layerName) => set((state) => ({
        layers: {
          ...state.layers,
          [layerName]: !state.layers[layerName],
        },
      })),
      
      setLoading: (loading) => set({ isLoading: loading }),
      setError: (error) => set({ error }),
      
      reset: () => set(initialState),
    }),
    {
      name: 'map-store',
    }
  )
);
